var React = require('react');

function FacebookFBrands (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.8925 36L36.67 24.4175H25.5562V16.9013C25.5562 13.7325 27.1087 10.6438 32.0862 10.6438H37.1387V0.7825C37.1387 0.7825 32.5537 0 28.17 0C19.0175 0 13.035 5.5475 13.035 15.59V24.4175H2.86121V36H13.035V64H25.5562V36H34.8925Z","fill":"white"}));
}

FacebookFBrands.defaultProps = {"width":"40","height":"64","viewBox":"0 0 40 64","fill":"none"};

module.exports = FacebookFBrands;

FacebookFBrands.default = FacebookFBrands;
